/**
 * @module modules/anomalies-table-sk
 * @description <h2><code>anomalies-table-skr: </code></h2>
 *
 * Display table of anomalies
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AnomaliesTableSk", {
    enumerable: true,
    get: function() {
        return AnomaliesTableSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _grouping = require("./grouping");
const _errorMessage = require("../errorMessage");
const _telemetry = require("../telemetry/telemetry");
const _httpstatuscodes = require("http-status-codes");
const _anomaly = require("../common/anomaly");
require("../window/window");
require("../triage-menu-sk/triage-menu-sk");
const _triagepanelsk = require("../triage-panel-sk/triage-panel-sk");
require("@material/web/button/outlined-button.js");
require("../../../elements-sk/modules/spinner-sk");
require("../../../elements-sk/modules/icons/arrow-drop-down-icon-sk");
require("../../../elements-sk/modules/icons/filter-list-icon-sk");
require("../../../elements-sk/modules/icons/arrow-drop-up-icon-sk");
require("../../../elements-sk/modules/icons/expand-less-icon-sk");
require("../../../elements-sk/modules/icons/expand-more-icon-sk");
require("../../../elements-sk/modules/icons/help-icon-sk");
const _keyboardshortcuts = require("../common/keyboard-shortcuts");
require("../keyboard-shortcuts-help-sk/keyboard-shortcuts-help-sk");
const _selectioncontroller = require("./selection-controller");
const _reportnavigationcontroller = require("./report-navigation-controller");
const _anomalygroupingcontroller = require("./anomaly-grouping-controller");
const _anomalytransformer = require("./anomaly-transformer");
require("./anomalies-grouping-settings-sk");
require("../bug-tooltip-sk/bug-tooltip-sk");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
const ANOMALIES_TABLE_SOURCE = 'anomalies-table-sk';
function matchesFilter(value, filterString) {
    var _filterString;
    const trimmed = (_filterString = filterString) === null || _filterString === void 0 ? void 0 : _filterString.trim();
    if (!trimmed) {
        return true;
    }
    try {
        return new RegExp(trimmed, 'i').test(value);
    } catch (_e) {
        // Fallback to simple substring matching if the regular expression is invalid
        return value.toLowerCase().includes(trimmed.toLowerCase());
    }
}
let AnomaliesTableSk = class AnomaliesTableSk extends _lit.LitElement {
    onOpenHelp() {
        const help = this.querySelector('keyboard-shortcuts-help-sk');
        help.open();
    }
    set anomalyList(val) {
        const oldVal = this._anomalyList;
        if (oldVal !== val) {
            this._anomalyList = val;
            this.initiallyRequestedAnomalyIDs.clear();
            this.selectionController.clear();
            this.requestUpdate('anomalyList', oldVal);
        }
    }
    get anomalyList() {
        return this._anomalyList;
    }
    // TODO(ansid): Consider computing `this.filteredAnomalies` once in `willUpdate`
    // and storing it in a private `@state` property to speed up filtering for large anomaly lists (e.g. 5k+ anomalies).
    get filteredAnomalies() {
        return this.anomalyList.filter((anomaly)=>{
            const processed = _anomalytransformer.AnomalyTransformer.getProcessedAnomaly(anomaly);
            if (this.filterBot && !matchesFilter(processed.bot, this.filterBot)) {
                return false;
            }
            if (this.filterBenchmark && !matchesFilter(processed.testsuite, this.filterBenchmark)) {
                return false;
            }
            if (this.filterTest && !matchesFilter(processed.test, this.filterTest)) {
                return false;
            }
            if (this.filterRevision) {
                const revVal = this.filterRevision.trim();
                const revNum = Number(revVal);
                const matchesRange = !isNaN(revNum) && anomaly.start_revision <= revNum && anomaly.end_revision >= revNum;
                const matchesString = anomaly.start_revision !== null && matchesFilter(String(anomaly.start_revision), revVal) || anomaly.end_revision !== null && matchesFilter(String(anomaly.end_revision), revVal);
                if (!matchesRange && !matchesString) {
                    return false;
                }
            }
            return true;
        });
    }
    set config(val) {
        this.groupingController.setConfig(val);
    }
    get config() {
        return this.groupingController.config;
    }
    createRenderRoot() {
        return this;
    }
    connectedCallback() {
        super.connectedCallback();
        // Move queries to firstUpdated or check for existence
        this.addEventListener('click', (e)=>{
            const triageButton = this.querySelector(`#triage-button-${this.uniqueId}`);
            const popup = this.querySelector('.popup');
            if (this.showPopup && !popup.contains(e.target) && e.target !== triageButton) {
                this.showPopup = false;
            }
        });
        this.addEventListener('anomaly-changed', ()=>{
            this.showPopup = false;
        });
        window.addEventListener('keydown', this.keyDown);
        window.addEventListener('click', this.onWindowClick);
    }
    firstUpdated() {
        this.triageMenu = this.querySelector(`#triage-menu-${this.uniqueId}`);
        if (this.triageMenu) {
            this.triageMenu.disableNudge();
        }
        this.headerCheckbox = this.querySelector(`#header-checkbox-${this.uniqueId}`);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('keydown', this.keyDown);
        window.removeEventListener('click', this.onWindowClick);
    }
    willUpdate(changedProperties) {
        const anomalyListChanged = changedProperties.has('anomalyList');
        const showTriagedChanged = changedProperties.has('showTriaged');
        const filtersChanged = [
            'filterBot',
            'filterBenchmark',
            'filterTest',
            'filterRevision'
        ].some((prop)=>changedProperties.has(prop));
        if (anomalyListChanged || showTriagedChanged || filtersChanged) {
            const filtered = this.filteredAnomalies;
            if (filtersChanged) {
                const filteredSet = new Set(filtered);
                const deselected = [];
                this.selectionController.items.forEach((item)=>{
                    if (!filteredSet.has(item)) {
                        this.selectionController.deselect(item);
                        deselected.push(item);
                    }
                });
                if (deselected.length > 0) {
                    this.dispatchEvent(new CustomEvent('anomalies_checked', {
                        detail: {
                            anomalies: deselected,
                            checked: false
                        },
                        bubbles: true
                    }));
                }
            }
            this.groupingController.setAnomalies(filtered);
            // ShowTriaged button should change default sort order if sortKey is 'revisions'.
            // Otherwise, we continue sorting by whatever user selected.
            if (showTriagedChanged && this.sortKey === 'revisions') {
                this.sortDirection = this.showTriaged ? 'down' : 'up';
            }
        }
    }
    handleSort(key) {
        if (this.sortKey === key) {
            this.sortDirection = this.sortDirection === 'up' ? 'down' : 'up';
        } else {
            this.sortKey = key;
            if (key === 'revisions') {
                this.sortDirection = this.showTriaged ? 'down' : 'up';
            } else {
                this.sortDirection = 'up';
            }
        }
    }
    getSortIcon(key) {
        if (this.sortKey !== key) {
            return (0, _lit.html)``;
        }
        return this.sortDirection === 'up' ? (0, _lit.html)`<arrow-drop-up-icon-sk></arrow-drop-up-icon-sk>` : (0, _lit.html)`<arrow-drop-down-icon-sk></arrow-drop-down-icon-sk>`;
    }
    getAriaSort(key) {
        if (this.sortKey !== key) {
            return 'none';
        }
        return this.sortDirection === 'up' ? 'ascending' : 'descending';
    }
    compareGroupAnomalyCounts(a, b) {
        if (!a.summaryData.calculated) {
            this.calculateSummaryForGroup(a);
        }
        if (!b.summaryData.calculated) {
            this.calculateSummaryForGroup(b);
        }
        const negA = a.summaryData.numRegressions;
        const negB = b.summaryData.numRegressions;
        if (negA !== negB) {
            // Default: most negative anomalies first
            return negB - negA;
        }
        const posA = a.summaryData.numImprovements;
        const posB = b.summaryData.numImprovements;
        // If negative anomalies tie, prioritize those that have less positive anomalies
        return posA - posB;
    }
    sortGroups(groups) {
        const up = this.sortDirection === 'up';
        return [
            ...groups
        ].sort((a, b)=>{
            // Because group sorting relies on sorting two keys, we cannot use the
            // single value generic comparison further below.
            if (this.sortKey === 'anomalyCount') {
                const diff = this.compareGroupAnomalyCounts(a, b);
                return up ? diff : -diff;
            }
            const valA = this.getGroupSortValue(a);
            const valB = this.getGroupSortValue(b);
            if (valA === valB) return 0;
            const comparison = typeof valA === 'string' && typeof valB === 'string' ? valA.localeCompare(valB) : valA > valB ? 1 : -1;
            return up ? comparison : -comparison;
        });
    }
    getGroupSortValue(group) {
        if (group.anomalies.length === 0) return '';
        // summary hasn't been calculated for the group yet, calculate & memoize it.
        if (group.summaryData.calculated === false) {
            this.calculateSummaryForGroup(group);
        }
        switch(this.sortKey){
            case 'anomalyCount':
                return group.summaryData.numRegressions;
            case 'bugid':
                return group.summaryData.bug;
            case 'revisions':
                return group.summaryData.endRevision;
            case 'bot':
                return group.summaryData.bot;
            case 'testsuite':
                return group.summaryData.testsuite;
            case 'test':
                return group.summaryData.test;
            case 'delta':
                return group.summaryData.delta;
            default:
                return '';
        }
    }
    onTriagePositive() {
        this.showPopup = true;
        // The second and third arguments are empty arrays because we are only
        // triaging anomalies, not trace keys or graph configs.
        this.triageMenu.fileBug();
    }
    onTriageNegative() {
        this.showPopup = true;
        // The second and third arguments are empty arrays because we are only
        // triaging anomalies, not trace keys or graph configs.
        this.triageMenu.ignoreAnomaly();
    }
    onTriageExisting() {
        this.showPopup = true;
        // The second and third arguments are empty arrays because we are only
        // triaging anomalies, not trace keys or graph configs.
        this.triageMenu.openExistingBugDialog();
    }
    onOpenReport() {
        void this.openReport();
    }
    onOpenGroupReport() {
        void this.openAnomalyGroupReportPage();
    }
    groupingSettingsTemplate() {
        return (0, _lit.html)`
      <anomalies-grouping-settings-sk
        .config=${_object_spread({}, this.groupingController.config)}
        @revision-mode-change=${(e)=>this.groupingController.setRevisionMode(e.detail)}
        @group-by-change=${(e)=>this.groupingController.toggleGroupBy(e.detail.criteria, e.detail.enabled)}></anomalies-grouping-settings-sk>
    `;
    }
    async toggleFilterPopup(e, column) {
        e.stopPropagation();
        this.activeFilterPopup = this.activeFilterPopup === column ? null : column;
        if (this.activeFilterPopup) {
            await this.updateComplete;
            const input = this.querySelector(`.header-filter-popup input`);
            if (input) {
                input.focus();
                input.select();
            }
        }
    }
    renderSortableHeader(sortKey, label, filterProp, filterPlaceholder) {
        const idPrefix = sortKey;
        const hasFilter = filterProp !== undefined;
        const filterValue = hasFilter ? this[filterProp] : '';
        const isFilterActive = filterValue.trim() !== '';
        const isPopupOpen = this.activeFilterPopup === sortKey;
        return (0, _lit.html)`
      <th
        id="${idPrefix}-${this.uniqueId}"
        class="${isPopupOpen ? 'has-active-popup' : ''}"
        aria-sort="${this.getAriaSort(sortKey)}">
        <div class="header-cell-container">
          <button class="sort-button" @click=${()=>this.handleSort(sortKey)}>
            ${label} ${this.getSortIcon(sortKey)}
          </button>
          ${hasFilter ? (0, _lit.html)`
                <div class="header-filter-container" @click=${(e)=>e.stopPropagation()}>
                  <button
                    class="filter-toggle-btn ${isFilterActive ? 'active' : ''}"
                    title="Filter ${label}"
                    @click=${(e)=>this.toggleFilterPopup(e, sortKey)}>
                    <filter-list-icon-sk></filter-list-icon-sk>
                  </button>
                  ${isPopupOpen ? (0, _lit.html)`
                        <div class="header-filter-popup">
                          <input
                            type="text"
                            placeholder="${filterPlaceholder || 'Filter...'}"
                            .value="${filterValue}"
                            @input=${(e)=>{
            this[filterProp] = e.target.value;
        }}
                            @keydown=${(e)=>{
            if (e.key === 'Escape' || e.key === 'Enter') {
                this.activeFilterPopup = null;
            }
        }}
                            autofocus />
                          <button
                            class="clear-filter-btn"
                            title="Clear filter and close"
                            @click=${()=>{
            this[filterProp] = '';
            this.activeFilterPopup = null;
        }}>
                            <close-icon-sk></close-icon-sk>
                          </button>
                        </div>
                      ` : ''}
                </div>
              ` : ''}
        </div>
      </th>
    `;
    }
    render() {
        const filtered = this.filteredAnomalies;
        const totalCount = filtered.length;
        const selectedCount = this.selectionController.size;
        // Checked only if ALL are selected
        const isAllSelected = totalCount > 0 && selectedCount === totalCount;
        // Indeterminate if SOME (but not all) are selected
        const isIndeterminate = selectedCount > 0 && selectedCount < totalCount;
        return (0, _lit.html)`
      <div class="filter-buttons" ?hidden="${this.anomalyList.length === 0}">
        <button
          id="triage-button-${this.uniqueId}"
          @click="${this.togglePopup}"
          ?disabled="${this.selectionController.size === 0}">
          Triage Selected
        </button>
        <button
          id="graph-button-${this.uniqueId}"
          @click="${this.openReport}"
          ?disabled="${this.selectionController.size === 0}">
          Graph Selected
        </button>
        <button
          id="open-group-button-${this.uniqueId}"
          @click="${this.openAnomalyGroupReportPage}"
          ?disabled="${this.selectionController.size === 0}">
          Graph Selected by Group
        </button>
        <label class="enable-triage-mode">
          <input
            id="triage-mode-${this.uniqueId}"
            type="checkbox"
            .checked=${this.triageMode}
            @change=${(e)=>{
            this.triageMode = e.target.checked;
            localStorage.setItem('perf-triage-mode-enabled', String(this.triageMode));
            this.dispatchEvent(new CustomEvent('triage-mode-changed', {
                detail: {
                    triageMode: this.triageMode
                },
                bubbles: true,
                composed: true
            }));
        }} />
          Enable Triage Mode
        </label>
        ${this.groupingSettingsTemplate()}
      </div>
      <div class="popup-container" ?hidden="${!this.showPopup}">
        <div class="popup">
          <triage-menu-sk
            id="triage-menu-${this.uniqueId}"
            .anomalies=${this.selectionController.items}
            .traceNames=${[]}></triage-menu-sk>
        </div>
      </div>
      <div class="triage-panel-container" ?hidden="${!this.triageMode}">
        <triage-panel-sk
          id="triage-panel-${this.uniqueId}"
          .anomalies=${this.anomalyList}
          .traceNames=${[]}
          @buckets-changed=${(e)=>this.activeBuckets = e.detail.buckets}>
        </triage-panel-sk>
      </div>
      <table
        id="anomalies-table-${this.uniqueId}"
        class="anomalies-table"
        ?hidden=${this.anomalyList.length === 0}>
        <tr class="headers">
          ${this.renderSortableHeader('anomalyCount', 'Anomaly Count')}
          <th id="checkbox-${this.uniqueId}">
            <label for="header-checkbox-${this.uniqueId}"
              ><input
                type="checkbox"
                id="header-checkbox-${this.uniqueId}"
                .checked=${isAllSelected}
                .indeterminate=${isIndeterminate}
                @change=${()=>{
            this.toggleAllCheckboxes();
        }}
            /></label>
          </th>
          <th id="graph_header-${this.uniqueId}">Chart</th>
          ${this.renderSortableHeader('bugid', 'Bug ID')}
          ${this.renderSortableHeader('revisions', 'Revisions', 'filterRevision', 'Filter rev...')}
          ${this.renderSortableHeader('bot', 'Bot', 'filterBot', 'Filter bot...')}
          ${this.renderSortableHeader('testsuite', 'Benchmark', 'filterBenchmark', 'Filter bench...')}
          ${this.renderSortableHeader('test', 'Test', 'filterTest', 'Filter test...')}
          ${this.renderSortableHeader('delta', 'Delta %')}
          <th id="triage-actions-${this.uniqueId}" ?hidden=${!this.triageMode}>Triage Buckets</th>
        </tr>
        <tbody id="rows-${this.uniqueId}">
          ${this.generateGroups()}
        </tbody>
      </table>
      <div class="empty-filter-msg" ?hidden=${this.anomalyList.length === 0 || filtered.length > 0}>
        No anomalies match the selected filters.
      </div>
      <keyboard-shortcuts-help-sk .handler=${this}></keyboard-shortcuts-help-sk>
      <h1 id="clear-msg-${this.uniqueId}" ?hidden=${this.anomalyList.length > 0 || this.loading}>
        No anomalies to triage. (If you expect anomalies, make sure you are logged in.)
      </h1>
    `;
    }
    async openReportForAnomalyIds(anomalies) {
        await this.reportNavigationController.openReportForAnomalyIds(anomalies);
    }
    async openReport() {
        await this.reportNavigationController.openReportForAnomalyIds(this.selectionController.items);
    }
    async handleAnomalyChartClick(e, anomaly) {
        if (e.type === 'click' && e.button !== 0) return;
        if (e.type === 'auxclick' && e.button !== 1) return;
        e.preventDefault();
        const newTab = window.open('', '_blank');
        if (newTab) {
            newTab.document.write('<title>Loading...</title>Loading graph...');
            newTab.document.close();
        }
        this.loadingGraphForAnomaly.set(anomaly.id, true);
        this.requestUpdate();
        await this.reportNavigationController.openMultiGraphUrl(anomaly, newTab, this.isDryRun);
        this.loadingGraphForAnomaly.set(anomaly.id, false);
        this.requestUpdate();
    }
    async handleGroupChartClick(e, anomalyGroup) {
        if (e.type === 'click' && e.button !== 0) return;
        if (e.type === 'auxclick' && e.button !== 1) return;
        e.preventDefault();
        const newTab = window.open('', '_blank');
        if (newTab) {
            newTab.document.write('<title>Loading...</title>Loading graph...');
            newTab.document.close();
        }
        await this.reportNavigationController.openReportForAnomalyIds(anomalyGroup.anomalies, newTab);
    }
    async openAnomalyGroupReportPage() {
        const reportPromises = this.groupingController.groups.filter((group)=>group.anomalies.some((a)=>this.selectionController.has(a))).map((group)=>this.reportNavigationController.openReportForAnomalyIds(group.anomalies));
        const results = await Promise.all(reportPromises);
        if (results.some((success)=>!success)) {
            (0, _errorMessage.errorMessage)('Popups blocked. Allow them (in the address bar) and retry', 0, {
                countMetricSource: _telemetry.CountMetric.FrontendErrorReported,
                source: ANOMALIES_TABLE_SOURCE,
                errorCode: _httpstatuscodes.StatusCodes.OK.toString()
            });
        }
    }
    togglePopup() {
        this.showPopup = !this.showPopup;
    }
    isGroupInitiallyRequested(group) {
        return group.anomalies.some((anomaly)=>this.initiallyRequestedAnomalyIDs.has(anomaly.id));
    }
    getStagedAnomalyIds() {
        if (!this.triageMode || !this.triagePanel) {
            return new Set();
        }
        return this.triagePanel.getStagedAnomalyIds();
    }
    generateGroups() {
        const stagedIds = this.getStagedAnomalyIds();
        const filteredGroups = this.groupingController.groups.map((g)=>{
            const newG = new _grouping.AnomalyGroup();
            newG.anomalies = g.anomalies.filter((a)=>!stagedIds.has(a.id));
            newG.expanded = g.expanded;
            return newG;
        }).filter((g)=>g.anomalies.length > 0);
        const sortedGroups = this.sortGroups(filteredGroups);
        if (!this.show_requested_groups_first || this.initiallyRequestedAnomalyIDs.size === 0) {
            return sortedGroups.map((group)=>this.generateRows(group));
        }
        const requestedGroups = [];
        const otherGroups = [];
        for (const group of sortedGroups){
            if (this.isGroupInitiallyRequested(group)) {
                requestedGroups.push(group);
            } else {
                otherGroups.push(group);
            }
        }
        const renderedRequested = requestedGroups.map((group)=>this.generateRows(group));
        const renderedOthers = otherGroups.map((group)=>this.generateRows(group, 'other-group'));
        if (requestedGroups.length === 0 || otherGroups.length === 0) {
            return [
                ...renderedRequested,
                ...renderedOthers
            ];
        }
        const separatorRow = (0, _lit.html)`
      <tr>
        <td colspan="9" class="separator-cell">
          <div class="separator-container">
            <span class="separator-line"></span>
            <span class="separator-text"
              >Other groups, related to requested ones (with overlapping commits range)</span
            >
            <span class="separator-line"></span>
          </div>
        </td>
      </tr>
    `;
        return [
            ...renderedRequested,
            [
                separatorRow
            ],
            ...renderedOthers
        ];
    }
    _updateCheckedState(chkbox, a) {
        if (chkbox) {
            if (chkbox.checked) {
                this.selectionController.select(a);
            } else {
                this.selectionController.deselect(a);
            }
        } else {
            this.selectionController.toggle(a);
        }
        this.dispatchEvent(new CustomEvent('anomalies_checked', {
            detail: {
                anomalies: [
                    a
                ],
                checked: this.selectionController.has(a)
            },
            bubbles: true
        }));
    }
    anomalyChecked(chkbox, a) {
        this._updateCheckedState(chkbox, a);
    }
    generateRows(anomalyGroup, rowClass = '') {
        const rows = [];
        const length = anomalyGroup.anomalies.length;
        this.calculateSummaryForGroup(anomalyGroup);
        if (length > 1) {
            rows.push(this.generateSummaryRow(anomalyGroup, rowClass));
            // optimization: if collapsed, do not render children
            if (!anomalyGroup.expanded) {
                return rows;
            }
        }
        // If it's a single item group, we always render it (it's not "expandable" in the same sense).
        // If it's a multi-item group, we only reach here if it is expanded.
        for(let i = 0; i < anomalyGroup.anomalies.length; i++){
            const anomalySortValues = _anomalytransformer.AnomalyTransformer.getProcessedAnomaly(anomalyGroup.anomalies[i]);
            const anomaly = anomalyGroup.anomalies[i];
            const processedAnomaly = _anomalytransformer.AnomalyTransformer.getProcessedAnomaly(anomaly);
            const anomalyClass = processedAnomaly.isImprovement ? 'improvement' : 'regression';
            const isLoading = this.loadingGraphForAnomaly.get(anomaly.id) || false;
            rows.push((0, _lit.html)`
        <tr
          data-bugid="${anomalySortValues.bugId}"
          data-revisions="${anomalySortValues.revision}"
          data-bot="${anomalySortValues.bot}"
          data-testsuite="${anomalySortValues.testsuite}"
          data-test="${anomalySortValues.test}"
          data-delta="${anomalySortValues.delta}"
          class="${this.getRowClass(i + 1, anomalyGroup)} ${rowClass}">
          <td></td>
          <td>
            <label
              ><input
                type="checkbox"
                @change=${(e)=>{
                this.anomalyChecked(e.target, anomaly);
            }}
                .checked=${this.selectionController.has(anomaly)}
                id="anomaly-row-${this.uniqueId}-${anomaly.id}"
            /></label>
          </td>
          <td class="center-content">
            ${isLoading ? (0, _lit.html)`<spinner-sk active></spinner-sk>` // Show spinner if loading
             : (0, _lit.html)`
                  <button
                    class="trendingicon-link"
                    @click=${(e)=>this.handleAnomalyChartClick(e, anomaly)}
                    @auxclick=${(e)=>this.handleAnomalyChartClick(e, anomaly)}>
                    <trending-up-icon-sk></trending-up-icon-sk>
                  </button>
                `}
          </td>
          <td class="tooltip-cell">
            ${this.getReportLinkForBugId(anomaly.bug_id)}
            <close-icon-sk
              id="btnUnassociate"
              @click=${()=>{
                this.triageMenu.makeEditAnomalyRequest([
                    anomaly
                ], [], 'RESET');
            }}
              ?hidden=${anomaly.bug_id === 0}>
            </close-icon-sk>
            <bug-tooltip-sk
              .bugs=${anomalyGroup.anomalies[i].bugs || []}
              totalLabel="total"></bug-tooltip-sk>
          </td>
          <td>
            <span
              >${_anomalytransformer.AnomalyTransformer.computeRevisionRange(anomaly.start_revision, anomaly.end_revision)}</span
            >
          </td>
          <td>${processedAnomaly.bot}</td>
          <td>${processedAnomaly.testsuite}</td>
          <td>${processedAnomaly.test}</td>
          <td class=${anomalyClass}>${(0, _anomaly.formatPercentage)(processedAnomaly.delta)}%</td>
          <td ?hidden=${!this.triageMode} @click=${(e)=>e.stopPropagation()}>
            <div class="bucket-buttons-group">
              ${this.activeBuckets.map((b)=>(0, _lit.html)`
                  <button
                    class="bucket-btn"
                    @click=${(e)=>{
                    e.stopPropagation();
                    this.onAddToBucket(b.name, [
                        anomaly
                    ]);
                }}>
                    ${b.name}
                  </button>
                `)}
            </div>
          </td>
        </tr>
      `);
        }
        return rows;
    }
    calculateSummaryForGroup(anomalyGroup) {
        if (!anomalyGroup.anomalies || anomalyGroup.anomalies.length === 0) {
            return;
        }
        if (anomalyGroup.summaryData.calculated) {
            return;
        }
        const [deltaValue, isSummaryRegression] = _anomalytransformer.AnomalyTransformer.determineSummaryDelta(anomalyGroup);
        const processedAnomalies = anomalyGroup.anomalies.map((a)=>_anomalytransformer.AnomalyTransformer.getProcessedAnomaly(a));
        const firstProcessed = processedAnomalies[0];
        // Aggregate Revisions
        const minStartRevision = Math.min(...anomalyGroup.anomalies.map((a)=>a.start_revision));
        const maxEndRevision = Math.max(...anomalyGroup.anomalies.map((a)=>a.end_revision));
        // Check for consistency
        const allSameBot = processedAnomalies.every((p)=>p.bot === firstProcessed.bot);
        const allSameTestSuite = processedAnomalies.every((p)=>p.testsuite === firstProcessed.testsuite);
        const anomalyForBugReportLink = this.getReportLinkForSummaryRowBugId(anomalyGroup);
        const bugIdForLink = anomalyForBugReportLink ? anomalyForBugReportLink.bug_id : 0;
        const numImprovements = anomalyGroup.anomalies.filter((a)=>a.is_improvement).length;
        const numRegressions = anomalyGroup.anomalies.length - numImprovements;
        const summaryData = {
            startRevision: minStartRevision,
            endRevision: maxEndRevision,
            bot: allSameBot ? firstProcessed.bot : '*',
            testsuite: allSameTestSuite ? firstProcessed.testsuite : '*',
            test: _anomalytransformer.AnomalyTransformer.findLongestSubTestPath(anomalyGroup.anomalies),
            delta: deltaValue,
            isSummaryRegression: isSummaryRegression,
            bug: bugIdForLink,
            numRegressions: numRegressions,
            numImprovements: numImprovements,
            calculated: true
        };
        anomalyGroup.summaryData = summaryData;
    }
    generateSummaryRow(anomalyGroup, rowClass = '') {
        if (!anomalyGroup.anomalies || anomalyGroup.anomalies.length === 0) {
            return (0, _lit.html)``; // Handle empty group
        }
        const improvements = anomalyGroup.anomalies.filter((a)=>a.is_improvement).length;
        const regressions = anomalyGroup.anomalies.length - improvements;
        const selectedCount = anomalyGroup.anomalies.filter((a)=>this.selectionController.has(a)).length;
        const totalCount = anomalyGroup.anomalies.length;
        // It is checked ONLY if ALL are selected
        const isChecked = totalCount > 0 && selectedCount === totalCount;
        // It is indeterminate if SOME (but not all) are selected
        const isIndeterminate = selectedCount > 0 && selectedCount < totalCount;
        const firstAnomaly = anomalyGroup.anomalies[0];
        const summaryBugs = this.getSummaryBugs(anomalyGroup.anomalies);
        const summaryData = anomalyGroup.summaryData;
        const summaryClass = summaryData.isSummaryRegression ? 'regression' : 'improvement';
        const anomalyForBugReportLink = this.getReportLinkForSummaryRowBugId(anomalyGroup);
        return (0, _lit.html)`
      <tr
        role="button"
        tabindex="0"
        aria-expanded="${anomalyGroup.expanded}"
        @click=${()=>this.expandGroup(anomalyGroup)}
        @keydown=${(e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.expandGroup(anomalyGroup);
            }
        }}
        data-bugid="${summaryData.bug}"
        data-revisions="${summaryData.endRevision}"
        data-bot="${summaryData.bot}"
        data-testsuite="${summaryData.testsuite}"
        data-test="${summaryData.test}"
        data-delta="${summaryData.delta}"
        class="${this.getRowClass(0, anomalyGroup)} ${rowClass} summary-row">
        <td>
          <span
            class="expand-indicator"
            title="${regressions} regressions, ${improvements} improvements"
            ?hidden=${anomalyGroup.anomalies.length === 1}>
            <expand-less-icon-sk ?hidden=${!anomalyGroup.expanded}></expand-less-icon-sk>
            <expand-more-icon-sk ?hidden=${anomalyGroup.expanded}></expand-more-icon-sk>
            <span class="regression">${regressions}</span> |
            <span class="improvement">${improvements}</span>
          </span>
        </td>
        <td>
          <label>
            <input
              type="checkbox"
              @click=${(e)=>e.stopPropagation()}
              @change="${(e)=>{
            e.stopPropagation();
            this.toggleChildrenCheckboxes(anomalyGroup);
        }}"
              .checked=${isChecked}
              .indeterminate=${isIndeterminate}
              id="anomaly-row-${this.uniqueId}-${this.getGroupId(anomalyGroup)}" />
          </label>
        </td>
        <td class="center-content">
          <button
            class="trendingicon-link"
            @click=${(e)=>{
            e.stopPropagation();
            this.handleGroupChartClick(e, anomalyGroup);
        }}
            @auxclick=${(e)=>{
            e.stopPropagation();
            this.handleGroupChartClick(e, anomalyGroup);
        }}>
            <trending-up-icon-sk></trending-up-icon-sk>
          </button>
        </td>
        <td class="tooltip-cell">
          ${this.getReportLinkForBugId(summaryData.bug)}
          <close-icon-sk
            id="btnUnassociate"
            @click=${(e)=>{
            e.stopPropagation();
            this.triageMenu.makeEditAnomalyRequest([
                anomalyForBugReportLink || firstAnomaly
            ], [], 'RESET');
        }}
            ?hidden=${!anomalyForBugReportLink}>
          </close-icon-sk>
          <bug-tooltip-sk
            @click=${(e)=>e.stopPropagation()}
            .bugs=${summaryBugs || []}
            totalLabel="distinct total"></bug-tooltip-sk>
        </td>
        <td>
          <span
            >${_anomalytransformer.AnomalyTransformer.computeRevisionRange(summaryData.startRevision, summaryData.endRevision)}</span
          >
        </td>
        <td>${summaryData.bot}</td>
        <td>${summaryData.testsuite}</td>
        <td>${summaryData.test}</td>
        <td class=${summaryClass}>${(0, _anomaly.formatPercentage)(summaryData.delta)}%</td>
        <td ?hidden=${!this.triageMode} @click=${(e)=>e.stopPropagation()}>
          <div class="bucket-buttons-group">
            ${this.activeBuckets.map((b)=>(0, _lit.html)`
                <button
                  class="bucket-btn"
                  @click=${(e)=>{
                e.stopPropagation();
                this.onAddToBucket(b.name, anomalyGroup.anomalies);
            }}>
                  ${b.name}
                </button>
              `)}
          </div>
        </td>
      </tr>
    `;
    }
    onAddToBucket(bucketName, anomalies) {
        if (this.triagePanel) {
            this.triagePanel.addToBucket(bucketName, anomalies);
            const deselected = [];
            anomalies.forEach((a)=>{
                if (this.selectionController.has(a)) {
                    this.selectionController.deselect(a);
                    deselected.push(a);
                }
            });
            if (deselected.length > 0) {
                this.dispatchEvent(new CustomEvent('anomalies_checked', {
                    detail: {
                        anomalies: deselected,
                        checked: false
                    },
                    bubbles: true
                }));
            }
            this.requestUpdate();
        }
    }
    getReportLinkForBugId(bug_id) {
        if (bug_id === 0) {
            return (0, _lit.html)``;
        }
        if (bug_id === -1) {
            return (0, _lit.html)`Invalid Alert`;
        }
        if (bug_id === -2) {
            return (0, _lit.html)`Ignored Alert`;
        }
        return (0, _lit.html)`<a
      href="http://b/${bug_id}"
      target="_blank"
      @click=${(e)=>e.stopPropagation()}
      >${bug_id}</a
    >`;
    }
    getReportLinkForSummaryRowBugId(anomalyGroup) {
        if (anomalyGroup.anomalies.every((a)=>a.bug_id === -2)) {
            return anomalyGroup.anomalies[0];
        }
        for (const anomaly of anomalyGroup.anomalies){
            if (anomaly.bug_id !== null && anomaly.bug_id !== 0 && anomaly.bug_id !== -2) {
                return anomaly;
            }
        }
        return undefined;
    }
    getRowClass(index, anomalyGroup) {
        if (anomalyGroup.expanded === true) {
            if (index === 0) {
                return 'parent-expanded-row';
            } else {
                return 'child-expanded-row';
            }
        }
        return '';
    }
    // Returns all distinct bugs in this FE group.
    getSummaryBugs(anomalies) {
        const distinctBugsMap = new Map();
        anomalies.flatMap((a)=>a.bugs || []).forEach((bug)=>{
            if (bug) {
                const key = `${bug.bug_id}-${bug.bug_type}`;
                if (!distinctBugsMap.has(key)) {
                    distinctBugsMap.set(key, bug);
                }
            }
        });
        return Array.from(distinctBugsMap.values());
    }
    expandGroup(anomalyGroup) {
        const matching = this.groupingController.groups.find((g)=>g === anomalyGroup || g.anomalies.some((a)=>anomalyGroup.anomalies.includes(a)));
        if (matching) {
            matching.expanded = !matching.expanded;
        } else {
            anomalyGroup.expanded = !anomalyGroup.expanded;
        }
        this.requestUpdate();
    }
    /**
   * Populates the table with the provided list of anomalies.
   * Deprecated: Use .anomalyList property instead.
   */ async populateTable(anomalyList) {
        this.anomalyList = anomalyList;
        await this.updateComplete;
    }
    /**
   * Set checkboxes to true for list of provided anomalies.
   * @param anomalyList

   */ checkSelectedAnomalies(anomalyList) {
        var _this_triageMenu;
        this.initiallyRequestedAnomalyIDs = new Set(anomalyList.map((a)=>a.id));
        this.anomalyList.forEach((anomaly)=>{
            if (this.initiallyRequestedAnomalyIDs.has(anomaly.id)) {
                this.selectionController.select(anomaly);
            }
        });
        (_this_triageMenu = this.triageMenu) === null || _this_triageMenu === void 0 ? void 0 : _this_triageMenu.toggleButtons(this.selectionController.items.length > 0);
        this.requestUpdate();
    }
    /**
   * Toggles the checked state of all child checkboxes within an anomaly group when the
   * group is collapsed. This allows the user to check/uncheck all children anomalies
   * at once by interacting with the parent checkbox.
   */ toggleChildrenCheckboxes(anomalyGroup) {
        const summaryRowCheckbox = this.querySelector(`input[id="anomaly-row-${this.uniqueId}-${this.getGroupId(anomalyGroup)}"]`);
        const checked = summaryRowCheckbox.checked;
        const affectedAnomalies = anomalyGroup.anomalies;
        affectedAnomalies.forEach((anomaly)=>{
            // We do not need to update individual checkboxes here because we are
            // re-rendering the whole table at the end of this function.
            if (checked) {
                this.selectionController.select(anomaly);
            } else {
                this.selectionController.deselect(anomaly);
            }
        });
        this.dispatchEvent(new CustomEvent('anomalies_checked', {
            detail: {
                anomalies: affectedAnomalies,
                checked: checked
            },
            bubbles: true
        }));
        // Header checkbox logic is now in the template (auto-calculated) or we update it?
        // The template calculates isAllSelected/isIndeterminate for the header based on checkedAnomaliesSet.
        // So if checkedAnomaliesSet is correct, header checkbox will render correctly.
        // BUT we need to notify Lit that checkedAnomaliesSet changed.
        this.requestUpdate();
    }
    /**
   * Toggles the 'checked' state of all checkboxes in the table based on the state of
   * the header checkbox. This provides a convenient way to select or deselect all
   * anomalies at once.
   */ toggleAllCheckboxes(forceChecked) {
        const headerCheckbox = this.querySelector(`#header-checkbox-${this.uniqueId}`);
        const filtered = this.filteredAnomalies;
        const totalCount = filtered.length;
        const selectedCount = this.selectionController.size;
        const isAllSelected = totalCount > 0 && selectedCount === totalCount;
        let checked = false;
        if (forceChecked !== undefined) {
            checked = forceChecked;
        } else if (headerCheckbox && headerCheckbox.checked !== isAllSelected) {
            checked = headerCheckbox.checked;
        } else {
            checked = !isAllSelected;
        }
        if (checked) {
            filtered.forEach((a)=>this.selectionController.select(a));
        } else {
            filtered.forEach((a)=>this.selectionController.deselect(a));
        }
        this.dispatchEvent(new CustomEvent('anomalies_checked', {
            detail: {
                anomalies: filtered,
                checked: checked
            },
            bubbles: true
        }));
        this.requestUpdate();
    }
    async openMultiGraphUrl(anomaly, newTab, isDryRun = false) {
        await this.reportNavigationController.openMultiGraphUrl(anomaly, newTab, isDryRun || this.isDryRun);
    }
    getCheckedAnomalies() {
        return this.selectionController.items;
    }
    initialCheckAllCheckbox() {
        if (this.headerCheckbox) {
            this.headerCheckbox.checked = true;
        }
        this.toggleAllCheckboxes(true);
    }
    /**
   * Generates a deterministic ID for an anomaly group based on the sorted IDs of its anomalies.
   * This ensures a unique and consistent ID for each group, preventing clashes.
   * @param anomalyGroup The anomaly group.
   * @returns A string ID for the group.
   */ getGroupId(anomalyGroup) {
        return `group-${anomalyGroup.anomalies.map((a)=>a.id).sort().join('-')}`;
    }
    constructor(...args){
        super(...args);
        this._anomalyList = [];
        this.showTriaged = false;
        this.isDryRun = false;
        this.showPopup = false;
        this.filterBot = '';
        this.filterBenchmark = '';
        this.filterTest = '';
        this.filterRevision = '';
        this.activeFilterPopup = null;
        this.triageMode = localStorage.getItem('perf-triage-mode-enabled') === 'true';
        this.sortKey = 'revisions';
        this.sortDirection = 'down';
        this.selectionController = new _selectioncontroller.SelectionController(this);
        this.reportNavigationController = new _reportnavigationcontroller.ReportNavigationController(this);
        this.groupingController = new _anomalygroupingcontroller.AnomalyGroupingController(this);
        this.initiallyRequestedAnomalyIDs = new Set();
        this.triageMenu = null;
        this.activeBuckets = [];
        this.headerCheckbox = null;
        this.shortcutUrl = '';
        this.loadingGraphForAnomaly = new Map();
        this.uniqueId = 'anomalies-table-sk-' + new Date().getTime() + '-' + Math.floor(Math.random() * 1000);
        this.show_requested_groups_first = false;
        this.onWindowClick = (e)=>{
            if (this.activeFilterPopup) {
                const composedPath = e.composedPath();
                const isInsideFilter = composedPath.some((node)=>{
                    var _node_classList, _node;
                    return (_node = node) === null || _node === void 0 ? void 0 : (_node_classList = _node.classList) === null || _node_classList === void 0 ? void 0 : _node_classList.contains('header-filter-container');
                });
                if (!isInsideFilter) {
                    this.activeFilterPopup = null;
                }
            }
        };
        this.keyDown = (e)=>{
            // Ignore if no anomalies selected
            if (this.selectionController.size === 0) {
                return;
            }
            if (!this.triageMenu) return;
            (0, _keyboardshortcuts.handleKeyboardShortcut)(e, this);
        };
        this.loading = false;
    }
};
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Array
    ])
], AnomaliesTableSk.prototype, "anomalyList", null);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    _ts_metadata("design:type", Boolean)
], AnomaliesTableSk.prototype, "showTriaged", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean,
        attribute: 'is-dry-run'
    }),
    _ts_metadata("design:type", Boolean)
], AnomaliesTableSk.prototype, "isDryRun", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Boolean)
], AnomaliesTableSk.prototype, "showPopup", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", String)
], AnomaliesTableSk.prototype, "filterBot", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", String)
], AnomaliesTableSk.prototype, "filterBenchmark", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", String)
], AnomaliesTableSk.prototype, "filterTest", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", String)
], AnomaliesTableSk.prototype, "filterRevision", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], AnomaliesTableSk.prototype, "activeFilterPopup", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Boolean)
], AnomaliesTableSk.prototype, "triageMode", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", String)
], AnomaliesTableSk.prototype, "sortKey", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", String)
], AnomaliesTableSk.prototype, "sortDirection", void 0);
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _grouping.AnomalyGroupingConfig === "undefined" ? Object : _grouping.AnomalyGroupingConfig
    ])
], AnomaliesTableSk.prototype, "config", null);
_ts_decorate([
    (0, _decorators.query)('triage-panel-sk'),
    _ts_metadata("design:type", typeof _triagepanelsk.TriagePanelSk === "undefined" ? Object : _triagepanelsk.TriagePanelSk)
], AnomaliesTableSk.prototype, "triagePanel", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Array)
], AnomaliesTableSk.prototype, "activeBuckets", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", typeof Map === "undefined" ? Object : Map)
], AnomaliesTableSk.prototype, "loadingGraphForAnomaly", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean,
        attribute: 'show-requested-groups-first',
        reflect: true
    }),
    _ts_metadata("design:type", Boolean)
], AnomaliesTableSk.prototype, "show_requested_groups_first", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    _ts_metadata("design:type", Boolean)
], AnomaliesTableSk.prototype, "loading", void 0);
AnomaliesTableSk = _ts_decorate([
    (0, _decorators.customElement)('anomalies-table-sk')
], AnomaliesTableSk);
